import { ProfileIconMenu as ProfileIconMenuWSC } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { t } from 'utilities/TranslationUtils';
import { useStores } from 'index';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const ProfileIconMenu = observer(({ setDisplayContent }: Props) => {
  const ss = useStores().startupStore;
  const ps = useStores().profileStore;

  return ss.bearerTokenProfileInfo ? (
    <ProfileIconMenuWSC
      label={'Profile'}
      name={ss.bearerTokenProfileInfo.name}
      surname={ss.bearerTokenProfileInfo.surname}
      profilePhotoUrl={ps.photoUrl ?? undefined}
      accountUrl={ss.config?.myAccountUrl}
      logoutUrl={ss.config?.logoutUrl ? ss.config.logoutUrl + '?returnUrl=' + window.origin : undefined}
      userOrganization={ss.bearerTokenProfileInfo.organizationName}
      onMenuItemClick={(menuItemUrl) => {
        setDisplayContent(false);
        window.location.href = menuItemUrl;
      }}
      logoutLabel={t('common.log_out')}
      accountLabel={t('common.my_profile')}
      supportLabel={t('common.support_and_faq')}
      supportUrl="https://trackman.zendesk.com/hc/en-us"
    />
  ) : null;
});

export default ProfileIconMenu;
